import React from 'react';
import SelectClient from './style';

export default function SelectCompanySincroniza({ setErrorCompany, setCompany, value }) {
  function handleClient(e) {
    let value = e.target.value;
    setCompany(value);
    if (value === '0') {
      setErrorCompany(true);
    }
    setErrorCompany(false);
  }

  return (
    <SelectClient>
      <p>Empresa</p>
      <select name="companiesOption" onChange={handleClient} value={value}>
        <option value="0">Escolha uma opção</option>
        <option value="Sincroniza Educação">Sincroniza Educação</option>
        <option value="Sincroniza Projetos">Sincroniza Projetos</option>
      </select>
    </SelectClient>
  );
}
